import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  CI: {
    callback: (item) => {
      let fci = `${
        item.dt_ultima_ficha != null
          ? utils.methods.formatDate(item.dt_ultima_ficha)
          : ''
      }\n(${item.percent_fci_completa ? item.percent_fci_completa + '%' : '%'})`
      return fci
    },
  },
  Acompanhamento: {
    callback: (item) => {
      if (item.dt_ultimo_acompanhamento == null) {
        return 'Sem atendimento'
      }
      let acompanhamento = `${utils.methods.formatDate(
        item.dt_ultimo_acompanhamento
      )}\n(${
        item.tp_ultimo_acompanhamento != null
          ? item.tp_ultimo_acompanhamento
          : ''
      })`
      return acompanhamento
    },
  },
}

export const chartOptions = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
    width: 2,
  },
  title: {
    text: '',
    align: 'center',
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5,
    },
  },
  xaxis: {
    // categories: ['01/2021', '02/2021', '03/2021', '04/2021', '05/2021', '06/2021', '07/2021', '08/2021', '09/2021', '10/2021', '11/2021', '12/2021']
    categories: [],
  },
  yaxis: {
    min: 0,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
  },
  markers: {
    size: 5,
  },
  annotations: {
    yaxis: [
      {
        y: 70,
        y2: 100,
        borderColor: '',
        fillColor: '#b3ffb3',
        label: {
          text: '',
        },
      },
      {
        y: 0,
        y2: 69,
        borderColor: '',
        fillColor: '#ffcccc',
        label: {
          text: '',
        },
      },
    ],
  },
  colors: ['#008FFB', '#ff9933', '#025e1b'],
}

export const municipioBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },
  xaxis: {
    categories: [
      'População IBGE',
      'População SISAB',
      'População e-SUS PEC',
      ['FCI atualizadas', 'e completas'],
      ['FCI desatualizadas', 'ou incompletas'],
      ['FCI meta semanal', 'de atualização'],
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#9E9E9E', '#0000ff', '#0faee1', '#8fce02', '#ff2121', '#ffa500'],
}

export const municipioCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },
      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
        },
      },
    },
  },

  colors: ['#a0d528'],
}

export const equipeBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },
  xaxis: {
    categories: [
      'População SISAB',
      'Cadastro mínimo',
      'População e-SUS PEC',
      'Cadastro máximo',
      ['FCI atualizadas', 'e completas'],
      ['FCI desatualizadas', 'ou incompletas'],
      ['FCI meta semanal', 'de atualização'],
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },
  colors: [
    '#0000ff',
    '#669999',
    '#0faee1',
    '#cccc00',
    '#8fce02',
    '#ff2121',
    '#ffa500',
  ],
}

export const equipeCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
        },
      },
    },
  },

  colors: ['#a0d528'],
}
export const acsBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
      categories: [
        '',
        '',
        '',
        '',
        ''
      ]
    }, */
  xaxis: {
    categories: [
      'População IBGE',
      'População e-SUS PEC',
      'Cadastros Atualizados',
      'Cadastros Desatualizados',
      'Cadastros a serem realizados',
      'Cadastros a serem atualizados (%)',
      ['Meta Semanal', 'de atualização'],
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffb635', '#b194e7', '#ff2121', '#16b1e3', '#0faee1'],
}

export const acsCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
        },
      },
    },
  },

  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 40) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const groupFilterItems = [
  { label: 'Ativos', value: 'ativos' },
  { label: 'Outra equipe', value: 'outra-equipe' },
  { label: 'Óbitos', value: 'obitos' },
  { label: 'Mudou-se', value: 'mudou-se' },
  { label: 'Atendimento recente', value: 'atendimento-recente' },
]

export const optionsTipoAcompanhamentoConsolidado = [
  {
    value: 'pessoas_acompanhadas',
    label: 'Pessoas acompanhadas',
    indicador: '30',
  },
  // { value: 'atendimento_medicina', label: 'Atendimento medicina' },
  // { value: 'atendimento_enfermagem', label: 'Atendimento enfermagem' },
  // {
  //   value: 'atendimento_outros_profissionais',
  //   label: 'Atendimento outros profissionais',
  // },
  // { value: 'atendimento_odonto', label: 'Atendimento odonto' },
  // { value: 'visitas_domiciliares', label: 'Visitas domiciliares' },
  // { value: 'atendimento_coletivo', label: 'Atendimento coletivo' },
  // { value: 'procedimentos', label: 'Procedimentos' },
]

export const optionsTipoAcompanhamentoClassificacao = [
  {
    value: 'acompanhamento-por-cadastro-esus',
    label: 'Acompanhamento por cadastro e-SUS',
    indicador: '36',
  },
  {
    value: 'acompanhamento-por-parametro-de-cadastro',
    label: 'Acompanhamento por parâmetro de cadastro',
    indicador: '55',
  },
  {
    value: 'vinculo-acompanhamento-por-cadastro-esus',
    label: 'Vínculo e acompanhamento por cadastro e-SUS',
    indicador: '37',
  },
  {
    value: 'vinculo-acompanhamento-por-parametro-de-cadastro',
    label: 'Vínculo e acompanhamento por parâmetro de cadastro',
    indicador: '56',
  },
]

export const infoHtml = ``
